import type { ParentComponent } from "../../lib/types";

const ListItem: ParentComponent = ({ children }) => <li>{children}</li>;

export { ListItem };
